<template>
  <div class="dhr-production">
    <h2 class="subtitle">What’s the lot number of your subparts?</h2>
    <div class="dhr-subparts">
      <h3 class="title">Subparts</h3>
      <div class="subparts-list">
        <div class="subparts-titles">
          <label class="lbl-amout">1</label>
          <!-- <label class="lbl-amout">#</label> -->
          <label class="padding-right">REF</label>
          <label>Batch Number</label>
        </div>
        <div class="subparts-content">
          <div
            class="subparts-row group-w-button"
            v-for="(part, index) in linkedSubparts"
            :key="index"
          >
            <span class="subpart-amout"> {{ part.amount }}x </span>
            <!-- <span class="subpart-amout">
              {{ part.amount * data.quantity }}x
            </span> -->
            <input
              autocomplete="off"
              type="text"
              class="subpart-disabled"
              :name="`linkedSubparts[${index}][ref]`"
              v-model="part.ref"
              disabled
            />
            <InputBonAutocomplete
              :hasNoLabel="true"
              class="subpart-input"
              :name="`linkedSubparts[${index}][bon]`"
              :restrictedPart="part.ref"
              :searchUrl="searchUrl"
              :isTextArea="false"
              placeholder="search ..."
              :isDisabled="false"
              :value="`linkedSubparts[${index}][bon]`"
              :amountNeeded="part.amount * data.quantity"
              v-model="part.bon"
              :key="part.partID + '-' + index"
              :hasMoreTop="true"
              @selectedItem="gotSelectedBon"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="btn-back" @click="$emit('gobackStep', true)">
      <BaseIcon name="chevron-left" class="icon margin-right" />
    </div>
    <div
      class="btn-next"
      :class="{ disabled: isIncomplete }"
      @click="!isIncomplete ? submitStep() : doNothing()"
    >
      <BaseIcon name="chevron-right" class="icon margin-right" />
    </div>
    <!-- <div class="btn-finish" :class="{'disabled': isIncomplete}" @click="!isIncomplete ? submitStep() : doNothing()">
      <span>Confirm DHR</span>
    </div> -->
  </div>
</template>
<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash";
import InputBonAutocomplete from "@/components/base/InputBonAutocomplete";

export default {
  components: {
    InputDash,
    BaseIcon,
    InputBonAutocomplete
  },
  props: {
    data: Object
  },
  data() {
    return {
      isIncomplete: true,
      ref: "",
      linkedSubparts: [],
      searchUrl: "production/checkbon/",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.ref = this.data.ref;
      this.getListSubparts();
    },
    getListSubparts() {
      var that = this;
      this.linkedSubparts = [];
      this.$http
        .get(
          this.$endpoint + "management/devices/assemblies/subparts/" + this.data.deviceID
        )
        .then(response => {
          var i;
          for (i = 0; i < response.data.length; i++) {
            that.linkedSubparts.push({
              partID: response.data[i].subPartID, 
              ref: response.data[i].realRef,
              bon: "",
              amount: response.data[i].amount
            });
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch(err => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });
    },
    gotSelectedBon(val) {
      // this.subparts.push({partID:val.bonPartID, bon:val.id})
       for (var i in this.linkedSubparts) {
         if (this.linkedSubparts[i].ref === val.ref) {
           this.linkedSubparts[i].bon = val.id;
          break;
        }
      }
      // this.changeBonForSubpart(val.bonPartID, val.id, val.name);
    },
    // changeBonForSubpart(subpartID, selectedBon, selecteddBon) {
    //   console.log(selectedBon)
    //   console.log(selecteddBon)
    //   console.log(subpartID)
    //   for (var i in this.linkedSubparts) {
    //     if (this.linkedSubparts[i].partID == subpartID) {
    //       this.linkedSubparts[i].bon = selectedBon;
    //       this.linkedSubparts[i].bon1 = selecteddBon;
    //       break;
    //     }
    //   }
    // },
    submitStep() {
      this.$emit("finishedStep", true);
    },
    doNothing() {
    },
    watchMe() {
      return this.linkedSubparts;
    }
  },
  watch: {
    linkedSubparts: {
      handler(val) {
        this.isIncomplete = false;
        val.forEach((subpart, index) => {
          if (subpart.bon == "") {
            this.isIncomplete = true;
          }
        });
        this.$emit("receiveData", {
          page: "subparts",
          subparts: this.linkedSubparts
        });
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/dhrFormProduction.scss";

.subparts-list {
  height: 100%;
  justify-content: flex-start !important;
}

.subparts-content {
  height: 100%;
}</style
>;
